// Sign-in-with-passkey button. Shown on the login page; conditionally
// rendered if `window.PublicKeyCredential` is available.

import { useState } from 'react';
import { Fingerprint } from 'lucide-react';
import { startAuthentication } from '@simplewebauthn/browser';
import { authApi } from '../lib/api';

interface Props {
  onAuth: () => void;
}

export default function PasskeyButton({ onAuth }: Props) {
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState<string | null>(null);

  const supported = typeof window !== 'undefined' && !!window.PublicKeyCredential;
  if (!supported) return null;

  async function handle() {
    setErr(null);
    setLoading(true);
    try {
      const opts = await authApi.passkeyAuthStart();
      const response = await startAuthentication(opts as Parameters<typeof startAuthentication>[0]);
      await authApi.passkeyAuthFinish(response);
      onAuth();
    } catch (e) {
      const msg = e instanceof Error ? e.message : 'Passkey sign-in failed';
      setErr(msg);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div>
      <button onClick={handle} disabled={loading} className="w-full btn-secondary justify-center py-2">
        <Fingerprint size={14} />
        {loading ? 'Waiting for passkey…' : 'Sign in with passkey'}
      </button>
      {err && <p className="text-xs text-red-600 mt-2">{err}</p>}
    </div>
  );
}
